// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as CustomScript$Showside from "../utils/CustomScript.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as ProductCardCTAButton$Showside from "./ProductCardCTAButton.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function GalleryButton(Props) {
  var product = Props.product;
  var variantId = Props.variantId;
  var match = ConfigurationProvider$Showside.use(undefined);
  var match$1 = match.config;
  var transitiveAccount = match$1.transitiveAccount;
  var settings = match$1.settings;
  var match$2 = EntrypointContext$Showside.use(undefined);
  var getLinkerParam = match$2.getLinkerParam;
  var customAction = Belt_Option.flatMap(Belt_Option.flatMap(settings.pdpGalleryCustomAction, function (action) {
    return action.id;
  }), function (id) {
    return Belt_Array.getBy(Belt_Option.mapWithDefault(transitiveAccount, [], function (account) {
      return account.customActions;
    }), function (action) {
      return Caml_obj.equal(action.id, id);
    });
  });
  var variant = Belt_Array.getBy(Belt_Array.concat(product.otherVariants, [product.firstVariant]), function (variant) {
    return variant.id === variantId;
  });
  var html = Belt_Option.flatMap(Belt_Option.flatMap(customAction, function (action) {
    return action.renderFn;
  }), function (code) {
    return CustomScript$Showside.triggerCustomFunctionReturningString(code, product, variant, "gallery button", undefined, undefined);
  });
  var handleClick = function (param) {
    Curry._1(getLinkerParam, undefined).then(function (linkerParam) {
      return CustomScript$Showside.triggerCustomFunction(Belt_Option.getWithDefault(Belt_Option.flatMap(customAction, function (action) {
        return action.onClickFn;
      }), ""), product, variant, undefined, "gallery button", linkerParam, undefined);
    });
  };
  if (customAction === undefined) {
    return null;
  }
  if (html !== undefined) {
    if (html === "") {
      return null;
    } else {
      return React.createElement("div", {
        className: CSS$Showside.prefix("inline-block cursor-pointer select-none flex flex-grow"),
        onClick: function ($$event) {
          $$event.stopPropagation();
          handleClick(undefined);
        },
        dangerouslySetInnerHTML: {
          __html: html
        }
      });
    }
  }
  var textColor = Belt_Option.flatMap(settings.pdpGalleryCustomAction, function (action) {
    return action.textColor;
  });
  var bgColor = Belt_Option.flatMap(settings.pdpGalleryCustomAction, function (action) {
    return action.bgColor;
  });
  var tmp = {};
  if (bgColor !== undefined) {
    tmp.backgroundColor = bgColor;
  }
  if (textColor !== undefined) {
    tmp.color = textColor;
  }
  var tmp$1 = {
    size: /* Md */2,
    style: tmp,
    onClick: handleClick,
    preventDefault: true,
    outline: true
  };
  var tmp$2 = Belt_Option.flatMap(settings.pdpGalleryCustomAction, function (action) {
    return action.label;
  });
  if (tmp$2 !== undefined) {
    tmp$1.label = tmp$2;
  }
  return React.createElement(ProductCardCTAButton$Showside.make, tmp$1);
}
GalleryButton.displayName = "GalleryButton";
var make = GalleryButton;
export { make };
/* react Not a pure module */